import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { DollarSign, TrendingUp, ArrowUpRight, ArrowDownRight, Download, MoreHorizontal } from 'lucide-react';
export function PaymentsPage() {
  const [activeTab, setActiveTab] = useState('Overview');
  const tabs = ['Overview', 'Invoices', 'Deposits', 'Settlements', 'Member Payouts'];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-6xl mx-auto" data-id="element-4089">
      {/* Header */}
      <div className="mb-6" data-id="element-4090">
        <h2 className="text-2xl font-bold" data-id="element-4091">Payments & Finance</h2>
      </div>

      {/* Tabs */}
      <div className="flex gap-6 border-b border-border mb-6 overflow-x-auto" data-id="element-4092">
        {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-3 text-sm font-medium whitespace-nowrap transition-colors ${activeTab === tab ? 'text-primary border-b-2 border-primary' : 'text-textMuted hover:text-textMain'}`} data-id="element-4093">
            {tab}
          </button>)}
      </div>

      {/* Tab Content */}
      <div className="pb-12" data-id="element-4094">
        {activeTab === 'Overview' && <div className="space-y-6" data-id="element-4095">
            {/* Cashflow Cards */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-4096">
              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-4097">
                <div className="text-sm text-textMuted mb-2" data-id="element-4098">
                  Expected Revenue
                </div>
                <div className="text-3xl font-bold text-textMain mb-2" data-id="element-4099">
                  $24,500
                </div>
                <div className="flex items-center text-xs text-textMuted" data-id="element-4100">
                  Across 14 confirmed shows
                </div>
              </div>
              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-4101">
                <div className="text-sm text-textMuted mb-2" data-id="element-4102">Collected</div>
                <div className="text-3xl font-bold text-green-500 mb-2" data-id="element-4103">
                  $8,200
                </div>
                <div className="flex items-center text-xs text-green-500 font-medium" data-id="element-4104">
                  <TrendingUp className="w-3 h-3 mr-1" data-id="element-4105" /> 33% of expected
                </div>
              </div>
              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-4106">
                <div className="text-sm text-textMuted mb-2" data-id="element-4107">Outstanding</div>
                <div className="text-3xl font-bold text-amber-500 mb-2" data-id="element-4108">
                  $6,100
                </div>
                <div className="flex items-center text-xs text-textMuted" data-id="element-4109">
                  Invoiced, awaiting payment
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4110">
              {/* Aged Receivables */}
              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-4111">
                <h3 className="text-lg font-semibold mb-4" data-id="element-4112">Aged Receivables</h3>
                <div className="space-y-4" data-id="element-4113">
                  <div className="flex justify-between items-center p-3 bg-background border border-border rounded-lg" data-id="element-4114">
                    <span className="text-sm" data-id="element-4115">0-30 days</span>
                    <span className="font-medium" data-id="element-4116">$4,500</span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-background border border-border rounded-lg" data-id="element-4117">
                    <span className="text-sm text-amber-500" data-id="element-4118">31-60 days</span>
                    <span className="font-medium text-amber-500" data-id="element-4119">$1,600</span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-background border border-border rounded-lg" data-id="element-4120">
                    <span className="text-sm text-red-500" data-id="element-4121">60+ days</span>
                    <span className="font-medium text-red-500" data-id="element-4122">$0</span>
                  </div>
                </div>
              </div>

              {/* Recent Transactions */}
              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-4123">
                <h3 className="text-lg font-semibold mb-4" data-id="element-4124">
                  Recent Transactions
                </h3>
                <div className="space-y-4" data-id="element-4125">
                  {[{
                desc: 'Deposit: The Empty Bottle',
                date: 'Today',
                amount: '+$750',
                type: 'in'
              }, {
                desc: 'Settlement: White Oak',
                date: 'Mar 21',
                amount: '+$1,250',
                type: 'in'
              }, {
                desc: 'Member Payout: Mark T.',
                date: 'Mar 22',
                amount: '-$300',
                type: 'out'
              }, {
                desc: 'Member Payout: Sarah C.',
                date: 'Mar 22',
                amount: '-$250',
                type: 'out'
              }].map((tx, i) => <div key={i} className="flex items-center justify-between pb-3 border-b border-border last:border-0 last:pb-0" data-id="element-4126">
                      <div className="flex items-center gap-3" data-id="element-4127">
                        <div className={`w-8 h-8 rounded-full flex items-center justify-center ${tx.type === 'in' ? 'bg-green-500/10 text-green-500' : 'bg-surfaceHover text-textMuted'}`} data-id="element-4128">
                          {tx.type === 'in' ? <ArrowDownRight className="w-4 h-4" data-id="element-4129" /> : <ArrowUpRight className="w-4 h-4" data-id="element-4130" />}
                        </div>
                        <div data-id="element-4131">
                          <div className="text-sm font-medium" data-id="element-4132">{tx.desc}</div>
                          <div className="text-xs text-textMuted" data-id="element-4133">
                            {tx.date}
                          </div>
                        </div>
                      </div>
                      <div className={`font-medium ${tx.type === 'in' ? 'text-green-500' : ''}`} data-id="element-4134">
                        {tx.amount}
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'Invoices' && <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-4135">
            <table className="w-full text-sm text-left" data-id="element-4136">
              <thead className="bg-background border-b border-border text-textMuted" data-id="element-4137">
                <tr data-id="element-4138">
                  <th className="px-6 py-4 font-medium" data-id="element-4139">Invoice #</th>
                  <th className="px-6 py-4 font-medium" data-id="element-4140">Date</th>
                  <th className="px-6 py-4 font-medium" data-id="element-4141">Show / Venue</th>
                  <th className="px-6 py-4 font-medium" data-id="element-4142">Amount</th>
                  <th className="px-6 py-4 font-medium" data-id="element-4143">Status</th>
                  <th className="px-6 py-4 text-right" data-id="element-4144">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-4145">
                {[{
              id: 'INV-2026-042',
              date: 'May 15, 2026',
              show: 'The Empty Bottle (Jun 12)',
              amount: '$750.00',
              status: 'Paid'
            }, {
              id: 'INV-2026-043',
              date: 'May 16, 2026',
              show: 'Beachland Tavern (Jun 14)',
              amount: '$900.00',
              status: 'Sent'
            }, {
              id: 'INV-2026-044',
              date: 'May 18, 2026',
              show: 'Higher Ground (Jun 18)',
              amount: '$1,100.00',
              status: 'Draft'
            }].map((inv, i) => <tr key={i} className="hover:bg-surfaceHover transition-colors" data-id="element-4146">
                    <td className="px-6 py-4 font-medium" data-id="element-4147">{inv.id}</td>
                    <td className="px-6 py-4 text-textMuted" data-id="element-4148">{inv.date}</td>
                    <td className="px-6 py-4 text-textMuted" data-id="element-4149">{inv.show}</td>
                    <td className="px-6 py-4 font-medium" data-id="element-4150">{inv.amount}</td>
                    <td className="px-6 py-4" data-id="element-4151">
                      <span className={`px-2 py-1 text-xs rounded font-medium ${inv.status === 'Paid' ? 'bg-green-500/10 text-green-500' : inv.status === 'Sent' ? 'bg-blue-500/10 text-blue-500' : 'bg-surface border border-border text-textMuted'}`} data-id="element-4152">
                        {inv.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-4153">
                      <button className="p-2 text-textMuted hover:text-primary transition-colors bg-background rounded-md border border-border" data-id="element-4154">
                        <Download className="w-4 h-4" data-id="element-4155" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>}

        {/* Other tabs would follow similar table patterns */}
        {(activeTab === 'Deposits' || activeTab === 'Settlements' || activeTab === 'Member Payouts') && <div className="bg-surface border border-border rounded-xl p-8 text-center text-textMuted" data-id="element-4156">
            Select the Overview or Invoices tab to see mock data for this view.
          </div>}
      </div>
    </motion.div>;
}